import React from 'react';
import { getCalendarEventsIncludedExcluded } from '../../../manage/activities/calendar/utils/calendar-utils';

interface CalendarOverflowWarningProps {
  events: any[];
  printCalendarRestrictions: {
    monthData: any;
    maxEventRows: any;
    maxChars: { small: number; regular: number } | number;
    eventRowLimits: number;
  };
  selectedMonth: Date;
}

export function CalendarOverflowWarning({
  events,
  printCalendarRestrictions,
  selectedMonth,
}: CalendarOverflowWarningProps) {
  if (!events || !printCalendarRestrictions) {
    return null;
  }

  const { maxChars, eventRowLimits } = printCalendarRestrictions;

  // maxChars is an object with small/regular properties, use small since eventRowLimits corresponds to small
  const maxCharsValue =
    typeof maxChars === 'object' ? maxChars.small : maxChars;

  // Extract the original announcement data from the calendar events
  const originalEvents = events
    .map((event) => event.original?.src)
    .filter(Boolean);

  if (originalEvents.length === 0) {
    return null;
  }

  const { sorted } = getCalendarEventsIncludedExcluded(
    originalEvents,
    maxCharsValue,
    eventRowLimits,
  );

  const excludedCount = sorted.excluded.length;

  if (excludedCount === 0) {
    return null;
  }

  return (
    <div className="warn">
      {excludedCount} event{excludedCount > 1 ? 's' : ''} will not appear on the
      print calendar due to space constraints.
    </div>
  );
}
